export const CARE_NEED_KEYS = [
  "companionship",
  "meals",
  "medication",
  "mobility",
  "hygiene",
  "housekeeping",
  "appointments",
] as const;

export type CareNeedKey = (typeof CARE_NEED_KEYS)[number];

export const PARENT_AGE_KEYS = ["60_69", "70_79", "80_89", "90_plus"] as const;
export type ParentAgeKey = (typeof PARENT_AGE_KEYS)[number];

export const LIVING_SITUATION_KEYS = ["alone", "spouse", "family", "care_home"] as const;
export type LivingSituationKey = (typeof LIVING_SITUATION_KEYS)[number];

export const TIMELINE_KEYS = ["asap", "1_3_months", "exploring"] as const;
export type TimelineKey = (typeof TIMELINE_KEYS)[number];

export const CONTACT_METHOD_KEYS = ["email", "phone", "whatsapp"] as const;
export type ContactMethodKey = (typeof CONTACT_METHOD_KEYS)[number];

export const SERVICE_COUNTRY_KEYS = [
  "serbia",
  "romania",
  "north_macedonia",
  "bulgaria",
  "hungary",
  "other",
] as const;

export type ServiceCountryKey = (typeof SERVICE_COUNTRY_KEYS)[number];

export type InquiryDetails = {
  parentName?: string;
  parentAge?: ParentAgeKey;
  parentCountry?: ServiceCountryKey;
  parentCity?: string;
  livingSituation?: LivingSituationKey;
  careNeeds: CareNeedKey[];
  careNeedsOther?: string;
  timeline?: TimelineKey;
  preferredContact?: ContactMethodKey;
  message?: string;
};

export const PLAN_LABELS: Record<string, string> = {
  pricing_essential: "Essential",
  pricing_comfort: "Comfort",
  pricing_premium: "Premium",
  general_inquiry: "General inquiry",
};
